import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/login/signlogo.png'


const _withScopeId = n => (_pushScopeId("data-v-02317a01"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  src: _imports_0
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "login-container" }
const _hoisted_6 = { class: "login-tabs" }
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_LoginForm = _resolveComponent("LoginForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      custom: "",
      to: "/"
    }, {
      default: _withCtx(({navigate}) => [
        _createElementVNode("div", {
          class: "login-logo",
          onClick: navigate
        }, _hoisted_4, 8, _hoisted_2)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("ul", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabList, (tab, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            class: _normalizeClass([{'is-active': _ctx.activeIndex == index}, "login-tabs-item"]),
            onClick: ($event: any) => (_ctx.activeIndex = index)
          }, _toDisplayString(tab), 11, _hoisted_7))
        }), 128))
      ]),
      _createVNode(_component_LoginForm, { type: _ctx.activeIndex }, null, 8, ["type"])
    ])
  ]))
}